var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c(_vm.dynamicComponent,{tag:"component",attrs:{"route":_vm.route,"page-data":_vm.page.data}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }